"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pxToRem = void 0;

var pxToRem = function pxToRem(px) {
  return "calc(".concat(px, " / var(--base-font-size, 12) * 1rem)");
};

exports.pxToRem = pxToRem;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJweFRvUmVtIiwicHgiXSwic291cmNlcyI6WyIuLi8uLi9zcmMvbGliL3B4VG9SZW0udHMiXSwic291cmNlc0NvbnRlbnQiOlsiZXhwb3J0IGNvbnN0IHB4VG9SZW0gPSAocHg6IG51bWJlcikgPT5cbiAgYGNhbGMoJHtweH0gLyB2YXIoLS1iYXNlLWZvbnQtc2l6ZSwgMTIpICogMXJlbSlgO1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBQU8sSUFBTUEsT0FBTyxHQUFHLFNBQVZBLE9BQVUsQ0FBQ0MsRUFBRDtFQUFBLHNCQUNiQSxFQURhO0FBQUEsQ0FBaEIifQ==